// @file Vuex Store module for Onboarding for a padlet that has just been created.
import { Module } from 'vuex'
import { RootState } from 'vuexstore/surface/types'

enum OnboardingStages {
  Settings = 'main',
  ReadyToPost = 'ready',
}

interface OnboardingState {
  isFirstView: boolean
  onboardingStage: OnboardingStages | null
}

const OnboardingModule: Module<OnboardingState, RootState> = {
  namespaced: true,
  state: {
    isFirstView: false,
    onboardingStage: null,
  },
  getters: {
    isFirstView(state): boolean {
      return state.isFirstView
    },
    isWallOnboardingFlow(state): boolean {
      return state.onboardingStage !== null
    },
    xReadyToPostPanel(state): boolean {
      return state.onboardingStage === OnboardingStages.ReadyToPost
    },
  },
  mutations: {
    SET_IS_FIRST_VIEW(state, isFirstView): void {
      state.isFirstView = isFirstView
    },
    CHANGE_ONBOARDING_STAGE(state, stage: OnboardingStages): void {
      state.onboardingStage = stage
    },
    END_ONBOARDING(state): void {
      state.onboardingStage = null
    },
  },
  actions: {
    setIsFirstView({ commit }, payload: boolean): void {
      commit('SET_IS_FIRST_VIEW', payload)
    },
    goOnboardingNextStage({ state, commit, dispatch }): void {},
    goOnboardingPreviousStage({ state, commit, dispatch }): void {},
    startOnboardingIfFirstView({ commit, getters, dispatch }): void {
      if (!getters.isFirstView) return
      commit('CHANGE_ONBOARDING_STAGE', OnboardingStages.Settings)
      dispatch('settings/showSettingsPanel', undefined, { root: true })
    },
    endOnboarding({ commit, dispatch, getters, rootGetters }): void {},
  },
}

export default OnboardingModule
export { OnboardingState }
